import { ReactElement } from "react";
import { RouterProvider, createBrowserRouter } from "react-router-dom";

import {
  AuthenticatedTemplate,
  UnauthenticatedTemplate,
} from "@azure/msal-react";
import { ChakraProvider, ColorModeScript } from "@chakra-ui/react";
import "focus-visible/dist/focus-visible";

import appRoutes from "appRoutes";
import { AuthChecker } from "components/AuthChecker";
import LoginRedirect from "components/LoginRedirect";
import AppInsightsProvider from "contexts/AppInsightsProvider";
import AuthProvider from "contexts/AuthProvider";
import AzureProvider from "contexts/AzureProvider";
import FeatureFlagProvider from "contexts/FeatureFlagContext";
import theme from "theme";

const router = createBrowserRouter(appRoutes, {
  basename: process.env.REACT_APP_BASENAME
    ? `/${process.env.REACT_APP_BASENAME}`
    : undefined,
});

export const App = (): ReactElement => (
  <FeatureFlagProvider>
    <ColorModeScript />
    <ChakraProvider theme={theme}>
      <AzureProvider>
        <AuthProvider>
          <AppInsightsProvider>
            <AuthenticatedTemplate>
              <AuthChecker>
                <RouterProvider router={router} />
              </AuthChecker>
            </AuthenticatedTemplate>
            <UnauthenticatedTemplate>
              <LoginRedirect />
            </UnauthenticatedTemplate>
          </AppInsightsProvider>
        </AuthProvider>
      </AzureProvider>
    </ChakraProvider>
  </FeatureFlagProvider>
);
